import { useQuery } from '@tanstack/react-query'

import type { GetAirportsBySearchParamResponse } from '../../types/index.js'

import { apiClient } from '../../lib/client.js'
import { airportKeys } from './keys.js'

export const useGetAirportsBySearchParamQuery = ({ searchParam }: { searchParam: string }) =>
  useQuery({
    queryFn: async () => {
      const response = await apiClient.client.get<GetAirportsBySearchParamResponse>(
        `/airport/search/${searchParam}`
      )
      return response.data
    },
    queryKey: airportKeys.bySearchParam(searchParam),
  })
